<div class="select-plan-wrapper" *ngIf="!showPopOver" [@fadeInOnEnter] [@fadeOutOnLeave]>
  <h2 class="box-title">Select a plan for your vehicle.</h2>
  <div class="description-box">
    Your vehicle is eligible for a Connected Car plan powered by Verizon.
    <p class="bold-part">Mobile number to Pair with Vehicle:</p>
    <p class="phone-part">{{mdn | mask: '(000) 000-0000' }}</p>
  </div>
  <div class="select-plan" *ngFor="let plan of plansData">
    <app-plan-selection-box
      (selectPlanMethod)="onSelectPlan($event)"
      [selectMode]="true"
      [dropdownsData]="dropdownData"
      [data]="plan">
    </app-plan-selection-box>
  </div>
  <div class="question-box" *ngIf="questionsData" id="#faqs">
    <h2 class="title">
      Have questions? We’ve got answers.
    </h2>
    <div class="question" *ngFor="let item of questionsData">
      <app-simple-accordion
        [boldTitle]="true"
        [arrowRight]="true"
        [description]="item.answer | phoneLink:'800.922.0204'"
        [title]="item.question">
      </app-simple-accordion>
      <hr class="divider"/>
    </div>
  </div>
</div>

